import { GET_BYBETJENTROLLER_URL } from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "BYBETJENTROLLER";

export function getBybetjentRoller() {
  return axiosUtils.GetAll(GET_BYBETJENTROLLER_URL, actionType);
}
